import { camelCase } from 'change-case';

import { logging, constants } from '@config';

function Facade () {
  this.handlers = {};
}

Facade.prototype = _.extend({}, Backbone.Events);
Facade.prototype.initialize = function () {
  _.bindAll(this, 'propagate', 'handle');

  this.editor = INKIVE.Tool.getInstance().editor;
  this.canvas = this.editor.canvas;

  Object.entries(this.handlers).forEach(([key, handler]) => {
    handler.initialize();
    handler.on('all', _.partial(this.propagate, key));
  });
};

Facade.prototype.handle = function (type, action, data) {
  const singleCall = (functionName, elementType, element) => {
    const elementHandler = this.handlers[elementType];
    const handler = elementHandler && elementHandler[functionName];
    const args = [element, data].filter(Boolean);

    if (typeof handler === 'function') {
      handler.call(elementHandler, ...args);
    }
  };

  let functionName = camelCase(type);
  if ((typeof type === 'string') && (typeof this[functionName]) === 'function') {
    return this[functionName](action, data);
  }

  if (action) {
    functionName = camelCase(action);

    if ((typeof type === 'string') && this.handlers[type] && (typeof this.handlers[type][functionName]) === 'function') {
      return this.handlers[type][functionName](data);
    }

    if ((typeof type === 'string') && (typeof this[functionName]) === 'function') {
      return this[functionName](type, data);
    }
  }

  if (!(typeof action === 'string') && !data) {
    data = action;
    const elements = [...this.canvas.getSelectedElems()];
    const returnValues = elements.map((element) => {
      const elementType = this.getType(element);
      return singleCall(functionName, elementType, element);
    });

    this.canvas.selectOnly([...this.canvas.getSelectedElems()]);

    return returnValues;
  } else {
    const element = document.getElementById(type);
    const elementType = this.handlers[type] ? type : this.getType(element);

    return singleCall(functionName, elementType, element);
  }
};

Facade.prototype.propagate = function (handler, eventKey, data) {
  const eventName = eventKey ? `${handler}.${eventKey}` : handler;
  this.trigger(eventName, data);
};

Facade.prototype.getType = function (element, id) {
  if (!element && id) {
    element = document.querySelector(`#${constants.background.image}[data-old-id=${id}]`);
  }
  if (!element) return;

  const hasClass = (className, el = element) => el?.classList?.contains(className);

  if (hasClass('no-restrictions')) return 'ignore-restrictions';
  if (hasClass('background', element.parentElement) || hasClass('background')) return 'background';
  if (hasClass('table')) return 'table';
  if (hasClass('video') || element.closest('.video')) return 'video';
  if (hasClass('logo')) return 'logo';
  if (hasClass('icon')) return 'icon';
  if (hasClass('textarea')) return 'text';
  if (hasClass('qrcode')) return 'qrcode';
  if (hasClass('sticker')) return 'sticker';
  if (hasClass('group')) return 'group';
  if (element.id === 'svgroot') return 'root';

  if (element.nodeName === 'image') {
    return hasClass('clipperImage', element.parentElement)
      ? 'imageclipper'
      : 'image';
  }

  return 'shape';
};

Facade.prototype.trigger = function (eventKey, data) {
  if (logging.logLevelDebug) {
    const timestamp = new Date().toLocaleTimeString();
    const facadeName = this.constructor.name;
    const loggedData = typeof data === 'string' && data.length > 120 ? data.substring(0, 120) + ' ...' : data;

    console.log(
      `%c${timestamp} %c${facadeName} %c${eventKey}`,
      'color: #999',
      'color: #999',
      'color: #fff',
      loggedData
    );
  }

  Backbone.Events.trigger.apply(this, arguments);
};

module.exports = Facade;
